/**
 * The server's article HTML refers to images by path (`/v1/public/media/…`),
 * which is relative to the API. Pages served from another host (the doctor's
 * site, the dashboard) need the API's address in front. Only `src="/v1/…"`
 * attributes are touched, and only for a plain http(s) origin.
 */
export function absolutizeMediaUrls(html: string, apiBaseUrl: string): string {
  const base = apiBaseUrl.replace(/\/+$/, "");
  if (!/^https?:\/\/[^\s"'<>]+$/.test(base)) return html;
  return html.replaceAll('src="/v1/public/media/', `src="${base}/v1/public/media/`);
}
